import { Layout, EditMessages as EditMessagesComponent } from "components"
export const EditMessages = () => {
 return (
  <Layout>
   <EditMessagesComponent />
  </Layout>
 )
}
